/* eslint-disable jsx-a11y/alt-text */
import React, { FunctionComponent, useEffect, useState } from 'react';
import ReactCrop, { Crop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import { useParams } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { ImageDto } from '../../dto/LectionImageDto';
import { BackDropDiv } from '../backdrop/BackDropDiv';
import { IAlertProps } from '../../interface/IAlertProps';
import {
  generateFilname,
  getDefaultAlertProps,
  getPageNumId,
  secureContent,
} from '../../utils/utils';
import { RESOURCE_URL } from '../../setting/AppSettings';
import { MyAlert } from '../UI/MyAlert';
import { CropDto } from '../../dto/CropDto';

interface Props {
  idPage: string;
  open: boolean;
  dto: ImageDto;
  onSave: (width: any, height: any, x: any, y: any) => void;
  onClose: () => void;
}

export const DialogZoomImage: FunctionComponent<Props> = ({
  idPage,
  open,
  dto,
  onSave,
  onClose,
}) => {
  const [crop, setCrop] = useState<Crop>();
  const [imageDto, setImageDto] = useState<ImageDto>(dto);
  const [cropDto, setCropDto] = useState<CropDto>({
    name: dto.name,
    x: 0,
    y: 0,
    w: 0,
    h: 0,
    name2: generateFilname(dto.name),
  });
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [backDrop] = useState(false);
  const handleClose = () => {
    onClose();
    setCropDto({
      name: '',
      x: 0,
      y: 0,
      w: 0,
      h: 0,
      name2: '',
    });
  };
  const handleSave = () => {
    onSave(cropDto.w, cropDto.h, cropDto.x, cropDto.y);
  };
  const { section, route } = useParams();
  const page = getPageNumId(idPage);

  const onCrpChange = (e: Crop) => {
    setCrop(e);
    cropDto.x = e.x;
    cropDto.y = e.y;
    cropDto.h = e.height;
    cropDto.w = e.width;
    setCropDto(cropDto);
  };

  const handleSaveCrop = async () => {
    handleSave();
    handleClose();
  };

  useEffect(() => {
    if (open) {
      setImageDto(dto);
      setCropDto({
        name: dto.name,
        x: 0,
        y: 0,
        w: 0,
        h: 0,
        name2: generateFilname(dto.name),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <div>
      <BackDropDiv open={backDrop} />
      <Dialog
        open={open}
        fullWidth
        maxWidth="xl"
        style={{ userSelect: 'none' }}
        PaperProps={{
          sx: { backgroundColor: '#e7ebee', width: '100%' },
        }}
      >
        <MyAlert
          message={alertProps.message}
          severity={alertProps.severity}
          onClose={() => setAlertProps({ ...alertProps, message: '' })}
        />
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontSize: '16px',
                textAlign: 'left',
                fontWeight: '600',
              }}
              component="text"
            >
              Выделение части
            </Typography>
            <IconButton size="medium" onClick={handleClose}>
              <CloseIcon fontSize="medium" />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={1} width={`${imageDto.width}px`}>
            <ReactCrop
              crop={crop}
              style={{
                width: `${imageDto.width}px`,
                height: `${imageDto.height}px`,
              }}
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              onChange={(c, p) => onCrpChange(c)}
            >
              <img
                style={{
                  width: `${imageDto.width}px`,
                  height: `${imageDto.height}px`,
                }}
                src={`https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${route}&page=page_${page}&name=${
                  imageDto.name
                }&${secureContent()}`}
              />
            </ReactCrop>
            <Stack alignItems="center">
              <IconButton size="medium" onClick={() => handleSaveCrop()}>
                <SaveIcon
                  fontSize="medium"
                  sx={{
                    color: '#2196f3',
                  }}
                />
              </IconButton>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
};
